import { delay } from 'redux-saga'
import { take, put, call, fork, cancel, select  } from 'redux-saga/effects'
import full from './full'
import summary from './summary'
import {getGameViewMode} from './common'
import * as GameViewMode from '../constants/GameViewMode'

export var DefaultPlayerMovementDuration = 5;

export default function* rootSaga () {
    let gameViewMode = yield select(getGameViewMode);
    
    if(gameViewMode !== GameViewMode.Full)
        DefaultPlayerMovementDuration = 1000;

    yield [
        gameViewMode === GameViewMode.Full ? fork(full) : fork(summary)
    ];
}


/** WEBPACK FOOTER **
 ** ./src/sagas/root.js
 **/